import React from "react";
import RtrButton from "components/design-system/rtr-button";

export type GridFilterControlsProps = {
  closeModal: () => void;
  onClearFilters: () => void;
};

/**
 * Basically a rewrite of FilterControls in TS.
 * The former is still used on the subscriber HP with different styling.
 */
const GridFilterControls = ({ closeModal, onClearFilters }: GridFilterControlsProps) => {
  const CLOSE_CTA = "Show Results";
  const CLEAR_CTA = "Clear All";

  const renderClearButton = () => {
    return (
      <RtrButton className="grow grow-2" onClick={onClearFilters} style="secondary">
        {CLEAR_CTA}
      </RtrButton>
    );
  };

  const renderCloseButton = () => {
    return (
      <RtrButton className="grow grow-2" onClick={closeModal}>
        {CLOSE_CTA}
      </RtrButton>
    );
  };

  return (
    <div className="bottom-0 fixed flex py-6 px-4 gap-x-3 bg-white z-100 w-full md:w-[30.5rem] border-t border-solid border-lighterGray">
      {renderClearButton()}
      {renderCloseButton()}
    </div>
  );
};

export default GridFilterControls;
